module.exports = __webpack_public_path__ + "img/index23.78f4e5bd.png";